import React, { useState } from 'react';
import { EMAIL, waLink } from '../data/content';

export const LEVELS = ['Basic Cleaning', 'Quality Cleaning', 'Precision Cleaning', 'Not sure yet'];
export const INDUSTRIES = ['Two-Wheeler', 'Passenger Vehicle', 'Commercial Vehicle', 'General Engineering', 'White Goods', 'Farm Equipment', 'Other'];

const inputCls = 'w-full bg-surface/70 border border-steelline px-4 py-3.5 text-sm text-paper placeholder:text-fog/50 focus:border-flame focus:outline-none transition-colors';
const labelCls = 'block font-mono text-[11px] uppercase tracking-[0.2em] text-fog mb-2';

const buildBrief = (form) =>
  [
    `Component: ${form.component || '—'}`,
    `Industry: ${form.industry}`,
    `Target cleanliness: ${form.level}`,
    `Company: ${form.company || '—'}`,
    `Name: ${form.name || '—'}`,
    `Phone / Email: ${form.phone || '—'} / ${form.email || '—'}`,
    form.message ? `Notes: ${form.message}` : ''
  ].filter(Boolean).join('\n');

function Field({ id, label, className = '', children }) {
  return (
    <div className={className}>
      <label htmlFor={id} className={labelCls}>{label}</label>
      {children}
    </div>
  );
}

function Select({ id, testid, options, value, onChange }) {
  return (
    <select id={id} data-testid={testid} className={inputCls} value={value} onChange={onChange}>
      {options.map((o) => <option key={o} value={o} className="bg-ink">{o}</option>)}
    </select>
  );
}

export default function ContactForm() {
  const [form, setForm] = useState({ name: '', company: '', email: '', phone: '', industry: INDUSTRIES[0], component: '', level: LEVELS[3], message: '' });
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const brief = buildBrief(form);
  const mailto = `mailto:${EMAIL}?subject=${encodeURIComponent('Component Cleaning Requirement — ' + (form.company || form.name || 'New Enquiry'))}&body=${encodeURIComponent(brief)}`;
  const whatsapp = waLink(`Hello Tekwash Systems,\n${brief}`);

  return (
    <form className="bg-surface/40 border border-steelline/60 p-8 lg:p-10" onSubmit={(e) => e.preventDefault()} data-testid="contact-rfp-form">
      <h2 className="font-display font-extrabold text-xl sm:text-2xl text-paper tracking-tight">Request a technical audit</h2>
      <p className="mt-2 text-sm text-fog">Fill the brief below, then send it straight to our inbox or WhatsApp.</p>

      <div className="mt-8 grid sm:grid-cols-2 gap-5">
        <Field id="cf-name" label="Your Name">
          <input id="cf-name" data-testid="contact-input-name" className={inputCls} value={form.name} onChange={set('name')} placeholder="Full name" />
        </Field>
        <Field id="cf-company" label="Company">
          <input id="cf-company" data-testid="contact-input-company" className={inputCls} value={form.company} onChange={set('company')} placeholder="Company name" />
        </Field>
        <Field id="cf-email" label="Email">
          <input id="cf-email" type="email" data-testid="contact-input-email" className={inputCls} value={form.email} onChange={set('email')} placeholder="you@company.com" />
        </Field>
        <Field id="cf-phone" label="Phone">
          <input id="cf-phone" type="tel" data-testid="contact-input-phone" className={inputCls} value={form.phone} onChange={set('phone')} placeholder="+91" />
        </Field>
        <Field id="cf-industry" label="Industry">
          <Select id="cf-industry" testid="contact-select-industry" options={INDUSTRIES} value={form.industry} onChange={set('industry')} />
        </Field>
        <Field id="cf-level" label="Target Cleanliness">
          <Select id="cf-level" testid="contact-select-level" options={LEVELS} value={form.level} onChange={set('level')} />
        </Field>
        <Field id="cf-component" label="Component To Clean" className="sm:col-span-2">
          <input id="cf-component" data-testid="contact-input-component" className={inputCls} value={form.component} onChange={set('component')} placeholder="e.g. Cylinder head, throttle body, gearbox housing" />
        </Field>
        <Field id="cf-message" label="Notes" className="sm:col-span-2">
          <textarea id="cf-message" rows={4} data-testid="contact-input-message" className={inputCls} value={form.message} onChange={set('message')} placeholder="Cycle time, throughput, current process, cleanliness spec…" />
        </Field>
      </div>

      <div className="mt-8 flex flex-wrap gap-4">
        <a href={mailto} data-testid="contact-send-email-button" className="bg-flame text-white font-semibold px-8 py-4 clip-notch hover:bg-flamedim transition-colors duration-200">
          Send via Email
        </a>
        <a href={whatsapp} target="_blank" rel="noopener noreferrer" data-testid="contact-send-whatsapp-button" className="border border-steelline text-paper px-8 py-4 font-mono text-xs uppercase tracking-[0.2em] hover:border-flame hover:text-flame transition-colors duration-200 flex items-center">
          Send via WhatsApp
        </a>
      </div>
    </form>
  );
}
